import DashboardApi from '@/api/main/main_page.js'

const state = {
    index_content: {},
    dashboard_content: {},
    dashboard_apps: {},
    view_id: '',
    app_info: {
        key: '',
        name: ''
    },
    page_info: {
        key: '',
        name: ''
    }
}

const mutations = {
    change_index_content(state, category) {
        state.index_content = category
    },
    get_dashboard_apps_content(state, apps) {
        state.dashboard_apps = apps
    },
    change_dashboard_content(state, libraryContent) {
        state.dashboard_content = libraryContent
    },
    change_main_view(state, view_id) {
        state.view_id = view_id
    }
}

const actions = {
    async get_dashboard_apps_content(context) {
        let apps = await DashboardApi.get_top_apps()
        // debugger
        // let d = {
        //     'blocks': [apps.data.blocks[4]],
        //     'nav': [apps.data.nav[0]],
        // }
        context.commit('get_dashboard_apps_content', apps)
    },

    async change_index_content(context) {
        let category = await DashboardApi.get_index_content()
        // debugger
        context.commit('change_index_content', category.data)
    },

    async change_dashboard_content(context, args) {
        let content = await DashboardApi.get_dashboard_content(args)
        context.commit('change_dashboard_content', content.data)
    },

    change_main_view(context, view_id) {
        context.commit('change_main_view', view_id)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
